// @ts-nocheck

import { createSelector } from 'reselect';

import { CBInfinite, GCBInfinite, XmasCBInfinite } from '../../../../assets/img/sports';
import { SportIconsBySportId } from '../../../../constants/ui/icons';
import { getItemIdOrOddIdFromProps } from '../../../../selectors/_propsGetters_';
import { selectEntitiesBets } from '../../../../selectors/entities/bets/entitiesBetsPrimary.selector';
import { selectEntitiesMatches } from '../../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { selectEntitiesOutcomes } from '../../../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';
import { selectPrivateOutcomeIconPath } from '../../../../selectors/outcome.selector';
import { MarketIds } from '../../../../types/market';
import { SportIds } from '../../../../types/sports';
import { selectOddsTravelAnimations } from '../animations';

const makeSelectOddsTravelAnimationProps = () => {
  const selectOddMatch = createSelector(
    [getItemIdOrOddIdFromProps, selectEntitiesOutcomes, selectEntitiesBets, selectEntitiesMatches],
    (oddId, outcomes, bets, matches) => {
      const betId = Object.keys(bets).find((key) => !!~(bets[key]?.outcomes?.indexOf(oddId) ?? -1));

      if (betId) {
        const castedBetId = parseInt(betId, 10);
        const matchId = Object.keys(matches).find(
          (key) => !!~(matches[key]?.bets?.indexOf(castedBetId) ?? -1) || matches[key]?.mainBetId === castedBetId,
        );

        if (matchId) {
          return matches[matchId];
        }
      }
    },
  );

  const selectAnimationByOddId = createSelector(
    [selectOddsTravelAnimations, getItemIdOrOddIdFromProps],
    (animations, oddId) => animations.find(({ oddId: animOddId }) => animOddId === oddId),
  );

  const selectOddSportId = createSelector([selectOddMatch, selectEntitiesMatches], (match) => match?.sportId);

  const selectIsBoostedOdd = createSelector([selectOddMatch, selectEntitiesBets], (match, bets) => {
    if (match && match.sportId === SportIds.SPECIAL_ODDS) {
      const bet = bets[match.mainBetId];

      return bet?.marketId === MarketIds.MARKET_ID_BOOSTED_BET;
    }
    return false;
  });

  const selectIsBigBoostedOdd = createSelector([selectOddMatch, selectEntitiesBets], (match, bets) => {
    if (match && match.sportId === SportIds.SPECIAL_ODDS) {
      const bet = bets[match.mainBetId];

      return bet?.marketId === MarketIds.MARKET_ID_BIG_BOOSTED_BET;
    }
    return false;
  });

  const selectIsXmasBoostedOdd = createSelector([selectOddMatch, selectEntitiesBets], (match, bets) => {
    if (match && match.sportId === SportIds.SPECIAL_ODDS) {
      const bet = bets[match.mainBetId];

      return bet?.marketId === MarketIds.MARKET_ID_XMAS_BOOSTED_BET;
    }
    return false;
  });

  const selectBoostedIconPath = createSelector(
    [selectAnimationByOddId, selectIsBoostedOdd, selectIsBigBoostedOdd, selectIsXmasBoostedOdd],
    (animation, isBoosted, isBigBoosted, isXmasBoosted) => {
      if (animation?.emoji) {
        return animation.emoji;
      }

      if (isBoosted) {
        return CBInfinite;
      }

      if (isBigBoosted) {
        return GCBInfinite;
      }

      if (isXmasBoosted) {
        return XmasCBInfinite;
      }

      return null;
    },
  );

  const selectDefaultIconPath = createSelector(
    [selectOddSportId, selectBoostedIconPath],
    (sportId, boostedIconPath) => boostedIconPath ?? SportIconsBySportId[sportId],
  );

  return createSelector([selectPrivateOutcomeIconPath, selectDefaultIconPath], (specialIconPath, defaultIconPath) => ({
    iconPath: specialIconPath ?? defaultIconPath,
    isSpecial: !!specialIconPath,
  }));
};

export default makeSelectOddsTravelAnimationProps;
